import { Paper, Container, Box, Typography } from '@mui/material';

export default function PayFooter() {
  return (
    <Paper
      sx={{
        marginTop: 'calc(10% + 60px)',
        width: '100%',
        position: 'fixed',
        bottom: 0,
      }}
      component="footer"
      square
    >
      <Container maxWidth="lg">
        <Box
          sx={{
            flexGrow: 1,
            justifyContent: "center",
            display: "flex",
            mb: 2,
            p: 1
          }}
        >
          <Typography variant="body2">
            주식회사 스페이스와이  |  대표자: 황현태  |  서울특별시 성동구 왕십리로 137, 119동 1층 108호 성동청년 창업이룸센터<br />
            0507-1368-2042  |  사업자등록번호 436-86-02104  |  통신판매업신고번호 2022-서울관악-0239 <br />
          </Typography>
        </Box>
      </Container>
    </Paper>
  );
}
